import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnDestroy, Renderer2 } from '@angular/core';
import { BorderConfig } from '../models';


@Directive({
    selector: '[borderStyle]',
    standalone: false
})
export class BorderDirective implements AfterViewInit, OnDestroy {
  @Input('borderStyle') set config(value: BorderConfig | null | undefined) {
    this._config = value;
    this.setBorder();
  }

  @Input() @HostBinding('class.shadow-eval-m-3') dropShadow = false;

  private _config: BorderConfig | null | undefined = null;

  private resizeObserver!: ResizeObserver;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(() => {
      this.setBorder();
    });

    this.resizeObserver.observe(this.el.nativeElement);

    this.setBorder();
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private setBorder(): void {
    const config = this._config;
    const elementWidth = this.el.nativeElement.offsetWidth;

    if (!config?.enabled || elementWidth === 0) {
      this.clearBorder();
      return;
    }

    const { color, width, style } = config;

    if (!width || !style) {
      this.clearBorder();
      return;
    }

    this.renderer.setStyle(
      this.el.nativeElement,
      'border',
      `${width} ${style} ${color ?? 'transparent'}`
    );
  }

  private clearBorder(): void {
    this.renderer.removeStyle(this.el.nativeElement, 'border');
  }
}
